import { Route } from '@angular/router';
import { hasAuthTypeOrRedirectGuard } from '@rma/authentication/public/util-auth-redirect';
import { logRedirectNonLegacy, RmaEmptyComponent, stripProfileRedirectAngularGuard } from '@rma/generic/util/router-utils';

export const indvidualRoutes: Route[] = [
  {
    path: 'agent',
    canActivate: [hasAuthTypeOrRedirectGuard('individual')],
    children: [
      // Remove after 2024-06-30 (check track js for logs) RealtorExportStepService in rma api (resolved) (2025-06-06)
      {
        path: 'external-linkable-reviews',
        canActivate: [logRedirectNonLegacy('/reviews/import')],
        canActivateChild: [logRedirectNonLegacy('/reviews/import')],
        component: RmaEmptyComponent,
        children: [
          {
            path: '**',
            component: RmaEmptyComponent,
          },
        ],
      },
      // Remove after 2024-06-30 (check track js for logs) hasPlatformAccess guard may of been the cause updated on (May 20th, 2025)
      {
        path: 'linked-accounts',
        canActivate: [stripProfileRedirectAngularGuard('/settings')],
        canActivateChild: [stripProfileRedirectAngularGuard('/settings')],
        children: [
          {
            path: '**',
            component: RmaEmptyComponent,
          },
        ],
      },
      // Remove after 2024-06-30 (check track js for logs) publish and manage was in public (resolved) (2025-06-06)
      {
        path: 'market-reports',
        canActivate: [stripProfileRedirectAngularGuard()],
        canActivateChild: [stripProfileRedirectAngularGuard()],
        children: [
          {
            path: '**',
            component: RmaEmptyComponent,
          },
        ],
      },
      // Remove after 2024-06-30 (check track js for logs) DC Common Url Provider DataFeed (resolved) (2025-06-06)
      {
        path: 'data-feeds',
        canActivate: [logRedirectNonLegacy('/settings/data-feeds')],
        component: RmaEmptyComponent,
      },
      // Remove after 2024-10-30 (check track js for logs) Still used marketor EasyReviewsJourneyService.cs (2025-06-06)
      {
        path: 'review-request-journey',
        loadChildren: () => import('@rma/reviews/review-request').then((m) => m.reviewRequestRedirectRoutes),
      },
    ],
  },
];
